module.exports = __webpack_public_path__ + "static/media/icon-download.e0ac2860.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/icon-download.svg
// module id = 348
// module chunks = 0